<div class="subscription-limit-wrapper">
    <div class="subscription-limit-title">
        {{ moduleName }} Creation Limit Reached ({{ subscriptionLimit?.allowedLicence }}/{{ subscriptionLimit?.consumedLicense }})
    </div>
    <div class="subscription-limit-message">
        Your organization has reached the subscribed {{ moduleName }} creation limit of <strong>{{ subscriptionLimit?.allowedLicence }}</strong> {{ moduleName }}.
        <br>To add more {{ moduleName }}, please consider upgrading your subscription plan.
        <br>If you need assistance or have any questions, feel free to contact our support team.
        <br><br>
        Thank you for understanding.
    </div>
</div>
